import React from 'react'
import {
  FormInputSelect,
  FormInput
} from 'camino-react'
import _ from 'lodash'

import { cloudhelpGet } from 'Utilities/CloudHelp'

class Client extends React.Component {
  constructor (props) {
    super()

    this.state = {
      currentClientContacts: []
    }
  }

  showTicketClientContacts = clientId => !_.isNil(clientId)

  getClientsContactsFromEndpoint = (clientId) => {
    cloudhelpGet(`/api/clients/${clientId}/users`)
      .then((response) => {
        const { data } = response
        const clientContacts = _.map(data, user => ({
          value: user.id,
          label: user.name,
          email: user.email
        }))

        this.setState({ currentClientContacts: clientContacts })
      })
  }

  getClientsContacts = (clientId) => {
    if (!_.isNil(clientId)) {
      this.getClientsContactsFromEndpoint(clientId)
    }
  }



  checkIfClientHasSameRegionAsSelectedTickets = (value) => {
    const {
      clients,
      setRegionToUpdate,
      getCategoryServiceByRegion,
      setErrorRegionClient,
      regionToUpdate,
      resetStateCategoryToDefault
    } = this.props

    const { region } = _.find(clients, ({ value }))
    if (region != regionToUpdate) {
      resetStateCategoryToDefault()
      setRegionToUpdate(region)
      setErrorRegionClient(`Selected Client is from different region than it was selected above.
      Please select another client or changes will be applied on those tickets and moved to a different region.`)
      getCategoryServiceByRegion(region)
    } else {
      setErrorRegionClient('')
    }
  }

  render () {
    const {
      getClientsContacts,
      showTicketClientContacts,
      checkIfClientHasSameRegionAsSelectedTickets
    } = this
    const {
      editedItem,
      clients
    } = this.props

    const { currentClientContacts } = this.state
    return (
      <div>
        <FormInput>
          <div key={editedItem.firstValueId}>
            <div>
              <FormInputSelect
                value={_.find(clients, ({ value: editedItem.clientId }))}
                isLoading={_.isEmpty(clients)}
                options={clients}
                onValue={(value) => {
                  editedItem.updateOptionValue('clientId', value)
                  getClientsContacts(value)
                  checkIfClientHasSameRegionAsSelectedTickets(value)
                }}
                clearable
                name="editedItem[clientId]"
                id="clientId"
              />
            </div>
          </div>
        </FormInput>
        {showTicketClientContacts(editedItem.clientId) && (
          <div>
            <FormInput>
              <div key={editedItem.clientId}>
                <FormInputSelect
                  placeholder="Client Contact"
                  value={_.find(currentClientContacts, ({ value: editedItem.clientContactId }))}
                  options={currentClientContacts}
                  onValue={(value) => { editedItem.updateOptionValue('clientContactId', value) }}
                  clearable
                  name="editedItem[clientContactId]"
                  id="clientContact"
                />
              </div>
            </FormInput>
          </div>
        )}
      </div>
    )
  }
}

export default Client
